import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import authService from '../services/authService';
import './Register.css';

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    passwordConfirm: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState('');

  // If already logged in, skip register and go to add-tutor
  useEffect(() => {
    authService.getCurrentUser()
      .then(data => { if (data.user) navigate('/add-tutor'); })
      .catch(() => {});
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = 'Էլ. հասցեն պարտադիր է';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Սխալ էլ. հասցե';
    }

    if (!formData.password) {
      newErrors.password = 'Գաղտնաբառը պարտադիր է';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Գաղտնաբառը պետք է լինի նվազագույնը 6 նիշ';
    }

    if (!formData.passwordConfirm) {
      newErrors.passwordConfirm = 'Կրկնեք գաղտնաբառը';
    } else if (formData.password !== formData.passwordConfirm) {
      newErrors.passwordConfirm = 'Գաղտնաբառերը չեն համընկնում';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError('');

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      await authService.register(
        formData.email.trim().toLowerCase(),
        formData.password,
        formData.passwordConfirm
      );

      // Redirect to add-tutor page
      navigate('/add-tutor');
    } catch (error) {
      console.error('Registration error:', error);
      setServerError(
        error.response?.data?.error || 
        'Ցավոք, սխալ է տեղի ունեցել։ Փորձեք նորից։'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-page">
      <div className="register-container">
        <div className="register-card">
          <h1 className="register-title">Ստեղծել հաշիվ</h1>
          <p className="register-subtitle">
            Գրանցվեք՝ մասնագետի պրոֆիլ ստեղծելու համար
          </p>

          {serverError && (
            <div className="error-banner">
              {serverError}
            </div>
          )}

          <form onSubmit={handleSubmit} className="register-form">
            <div className="form-group">
              <label htmlFor="email">
                Էլ. հասցե <span className="required">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? 'error' : ''}
                placeholder="your@email.com"
                disabled={loading}
              />
              {errors.email && (
                <span className="error-text">{errors.email}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="password">
                Գաղտնաբառ <span className="required">*</span>
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className={errors.password ? 'error' : ''}
                placeholder="Նվազագույնը 6 նիշ"
                disabled={loading}
              />
              {errors.password && (
                <span className="error-text">{errors.password}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="passwordConfirm">
                Կրկնել գաղտնաբառը <span className="required">*</span>
              </label>
              <input
                type="password"
                id="passwordConfirm"
                name="passwordConfirm"
                value={formData.passwordConfirm}
                onChange={handleChange}
                className={errors.passwordConfirm ? 'error' : ''}
                placeholder="Կրկնեք գաղտնաբառը"
                disabled={loading}
              />
              {errors.passwordConfirm && (
                <span className="error-text">{errors.passwordConfirm}</span>
              )}
            </div>

            <button
              type="submit"
              className="register-btn"
              disabled={loading}
            >
              {loading ? 'Խնդրում ենք սպասել...' : 'Շարունակել'}
            </button>
          </form>
          <p className="register-login-link">
            Արդեն ունե՞ք հաշիվ։ <Link to="/login">Մուտք գործել</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
